import { types, applySnapshot } from 'mobx-state-tree';

const NotificationModel = types
  .model('NotificationState', {
    open: false,
    type: '',
    message: '',
    langMessage: types.optional(types.union(types.string, types.array(types.string)), ''),
    duration: 10000
  })
  .actions((self) => ({
    set(alert) {
      applySnapshot(self, alert);
    }
  }));

export default NotificationModel;
